import { create } from 'zustand/react';

import type { Dictionary } from '@/shared/legacy/contexts/LocalizationContext/types';

export type Language = 'nl' | 'en';

type I18nStore = {
  dictionary: Dictionary;
  language: Language;
  setDictionary: (dictionary: Dictionary) => void;
  setLanguage: (language: Language) => void;
};

export const useI18nStore = create<I18nStore>((set) => ({
  dictionary: {} as unknown as Dictionary,
  language: 'nl',
  setDictionary: (dictionary) => set({ dictionary }),
  setLanguage: (language) => set({ language }),
}));
